import type { LucideIcon } from 'lucide-react';
import {
  LayoutDashboard,
  Building2,
  Users,
  Phone,
  Calendar,
  MessageSquare,
  MessagesSquare,
  Bot,
  ShoppingCart,
  Video,
  FolderOpen,
  BarChart3,
  AlarmClock,
  Briefcase,
  Settings,
} from 'lucide-react';

/**
 * Registry tipizzato dei moduli W3 Suite (Task #3263).
 * UNICO punto di accensione/spegnimento: il filtro è UX, MAI security —
 * l'authority resta il backend (JWT + RLS + permission).
 */
export interface W3Module {
  id: string;
  label: string;
  icon: LucideIcon;
  /** Route relativa allo slug tenant (es. `dashboard` → `/:slug/dashboard`). */
  route: string;
  enabled: boolean;
  /** true = pagina implementata; false = placeholder "in arrivo". */
  implemented: boolean;
}

export const W3_MODULES: readonly W3Module[] = [
  { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, route: 'dashboard', enabled: true, implemented: true },
  { id: 'organizzazione', label: 'Organizzazione', icon: Building2, route: 'organizzazione', enabled: true, implemented: true },
  { id: 'crm', label: 'CRM', icon: Users, route: 'crm', enabled: true, implemented: false },
  { id: 'centralino', label: 'Centralino', icon: Phone, route: 'centralino', enabled: true, implemented: false },
  { id: 'pos', label: 'POS & Inventario', icon: ShoppingCart, route: 'pos', enabled: true, implemented: false },
  { id: 'calendario', label: 'Calendario', icon: Calendar, route: 'calendario', enabled: true, implemented: false },
  { id: 'chat-clienti', label: 'Chat Clienti', icon: MessageSquare, route: 'chat-clienti', enabled: true, implemented: false },
  { id: 'messenger', label: 'Messenger', icon: MessagesSquare, route: 'messenger', enabled: true, implemented: false },
  { id: 'ai', label: 'AI Tools', icon: Bot, route: 'ai', enabled: true, implemented: false },
  { id: 'video', label: 'Video Call Live', icon: Video, route: 'video', enabled: true, implemented: false },
  { id: 'hr', label: 'HR', icon: Briefcase, route: 'hr', enabled: true, implemented: false },
  { id: 'file-manager', label: 'File Manager', icon: FolderOpen, route: 'files', enabled: true, implemented: false },
  { id: 'analytics', label: 'Analytics', icon: BarChart3, route: 'analytics', enabled: true, implemented: false },
  // Modulo sveglia: parte DISABILITATO da spec (riattivabile da qui).
  { id: 'wakeup', label: 'Sveglia', icon: AlarmClock, route: 'wakeup', enabled: false, implemented: false },
  { id: 'impostazioni', label: 'Impostazioni', icon: Settings, route: 'impostazioni', enabled: true, implemented: false },
];

export function enabledModules(): readonly W3Module[] {
  return W3_MODULES.filter((m) => m.enabled);
}
